// Holding page replacing the previous public-scan tool. The prior
// implementation hit a non-existent /api/scan/public endpoint, then
// fell back to a hardcoded SAMPLE_RESULTS array with Math.random()
// URL suffixes — every user saw fabricated leak data. Removed
// entirely. Real public-scan backend will land separately and this
// page will be re-enabled with honest results.

export default function Scan() {
  return (
    <div style={{ minHeight: "100vh", background: "#06060a", color: "#f0ede8", fontFamily: "'DM Sans', sans-serif" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500&family=DM+Serif+Display:ital@0;1&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        .btn-cta { background: #7B5EA7; color: #fff; border: none; border-radius: 8px; padding: 16px 32px; font-size: 16px; font-weight: 500; cursor: pointer; font-family: inherit; transition: background 0.2s; width: 100%; max-width: 320px; }
        .btn-cta:hover { background: #6a4f93; }
      `}</style>

      {/* Nav */}
      <nav style={{ padding: "20px 40px", display: "flex", alignItems: "center", justifyContent: "space-between", borderBottom: "0.5px solid rgba(255,255,255,0.06)" }}>
        <a href="/" style={{ display: "flex", alignItems: "center", gap: 8, textDecoration: "none", color: "#f0ede8" }}>
          <div style={{ width: 28, height: 28, borderRadius: 6, background: "#7B5EA7", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14, fontWeight: 600 }}>C</div>
          <span style={{ fontSize: 15, fontWeight: 500 }}>Creator Protect</span>
        </a>
        <div style={{ display: "flex", gap: 12 }}>
          <a href="/login" style={{ fontSize: 14, color: "rgba(240,237,232,0.5)", textDecoration: "none" }}>Log in</a>
          <a href="/signup" style={{ fontSize: 14, color: "#fff", background: "#7B5EA7", padding: "8px 16px", borderRadius: 6, textDecoration: "none" }}>Start free trial</a>
        </div>
      </nav>

      {/* Hero — holding page */}
      <div style={{ padding: "60px 24px 80px", textAlign: "center", position: "relative", overflow: "hidden" }}>
        <div style={{ position: "absolute", width: 500, height: 500, borderRadius: "50%", background: "rgba(123,94,167,0.08)", filter: "blur(80px)", top: -200, left: "50%", transform: "translateX(-50%)", pointerEvents: "none" }} />
        <div style={{ position: "relative", zIndex: 1, maxWidth: 640, margin: "0 auto" }}>

          <div style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "rgba(123,94,167,0.1)", border: "0.5px solid rgba(123,94,167,0.25)", borderRadius: 20, padding: "5px 14px", fontSize: 12, fontWeight: 500, color: "#a78fd4", letterSpacing: "0.04em", marginBottom: 24 }}>
            COMING SOON
          </div>

          <h1 style={{ fontFamily: "'DM Serif Display', serif", fontSize: "clamp(32px, 6vw, 56px)", fontWeight: 400, lineHeight: 1.1, marginBottom: 20 }}>
            We're rebuilding our<br />
            <span style={{ fontStyle: "italic", color: "#a78fd4" }}>public scanner</span>
          </h1>

          <p style={{ fontSize: 16, color: "rgba(240,237,232,0.65)", lineHeight: 1.7, maxWidth: 520, margin: "0 auto 16px" }}>
            We're upgrading our public scan tool to deliver more accurate results across 14 piracy hosts, Google, Yandex, paste sites, and dark web sources.
          </p>

          <p style={{ fontSize: 15, color: "rgba(240,237,232,0.55)", lineHeight: 1.7, maxWidth: 520, margin: "0 auto 36px" }}>
            In the meantime, sign up for a free 3-day Pro trial to get full continuous monitoring with automatic DMCA takedowns.
          </p>

          <div style={{ display: "flex", justifyContent: "center" }}>
            <button className="btn-cta" onClick={() => window.location.href = "https://buy.stripe.com/6oUbIV4pK5jQ1x13IgdQQ03"}>
              Start 3-day free trial
            </button>
          </div>
          <p style={{ fontSize: 12, color: "rgba(240,237,232,0.3)", marginTop: 16 }}>
            Cancel anytime
          </p>

        </div>
      </div>
    </div>
  );
}
